import { Component, Input } from '@angular/core';

/**
 * Shown in place of content the server refused with a 403. Kept separate from
 * app-error-alert: a permission wall is not a transient error the user can retry,
 * and the shortage-style detail an alert carries would be noise here.
 */
@Component({
  selector: 'app-not-authorized',
  standalone: false,
  templateUrl: './not-authorized.component.html',
  styleUrl: './not-authorized.component.scss',
})
export class NotAuthorizedComponent {
  @Input() title: string = 'You do not have access to this';
  @Input() message: string = 'This section is restricted to administrators. Ask an admin if you need it.';
}
